import { render, staticRenderFns } from "./tipogestores.vue?vue&type=template&id=3c941b15&scoped=true&"
import script from "./tipogestores.vue?vue&type=script&lang=js&"
export * from "./tipogestores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c941b15",
  null
  
)

export default component.exports